export enum RedirectType {
  SHOPIFY = 'shopify_connection',
  WOO_COMMERCE = 'woocommerce_connection',
  HUBSPOT = 'hubspot_connection',
  ZOHO = 'zohocrm_connection',

  SHOPIFY_RECONNECTION = 'shopify_reconnection',
  WOO_COMMERCE_RECONNECTION = 'woocommerce_reconnection',
  HUBSPOT_RECONNECTION = 'hubspot_reconnection',
  HUBSPOT_MARKETPLACE_INSTALL = 'hubspot_marketplace_install',
  ZOHO_RECONNECTION = 'zohocrm_reconnection',
  AUTOMATION_LOGS = 'automation_logs',
}

export enum RedirectStatus {
  ERROR = 'error',
}

// Backend connection-error codes surfaced via the redirect URL's `errorCode` query param.
export enum RedirectErrorCode {
  STORE_ALREADY_CONNECTED = 'integration.store_already_connected',
}

// The backend may append an error to any connection redirect, e.g.
// /redirect?status=error&type=hubspot_connection&errorCode=integration.store_already_connected
type RedirectErrorParams = {
  status?: RedirectStatus
  errorCode?: RedirectErrorCode
}

export type ShopifyRedirectParams = RedirectErrorParams & {
  type: RedirectType.SHOPIFY
}

export type WoocommerceRedirectParams = RedirectErrorParams & {
  type: RedirectType.WOO_COMMERCE
}

export type HubspotRedirectParams = RedirectErrorParams & {
  type: RedirectType.HUBSPOT
}

export type ZohoRedirectParams = RedirectErrorParams & {
  type: RedirectType.ZOHO
}

export type ShopifyReconnectionRedirectParams = RedirectErrorParams & {
  type: RedirectType.SHOPIFY_RECONNECTION
}

export type WoocommerceReconnectionRedirectParams = RedirectErrorParams & {
  type: RedirectType.WOO_COMMERCE_RECONNECTION
}

export type HubspotReconnectionRedirectParams = RedirectErrorParams & {
  type: RedirectType.HUBSPOT_RECONNECTION
}

export type HubspotMarketplaceInstallRedirectParams = {
  type: RedirectType.HUBSPOT_MARKETPLACE_INSTALL
  returnUrl: string
}

export type ZohoReconnectionRedirectParams = RedirectErrorParams & {
  type: RedirectType.ZOHO_RECONNECTION
}

export type AutomationLogsRedirectParams = {
  type: RedirectType.AUTOMATION_LOGS
  automationId: string
}

export type RedirectParams =
  | ShopifyRedirectParams
  | WoocommerceRedirectParams
  | HubspotRedirectParams
  | ZohoRedirectParams
  | ShopifyReconnectionRedirectParams
  | WoocommerceReconnectionRedirectParams
  | HubspotReconnectionRedirectParams
  | HubspotMarketplaceInstallRedirectParams
  | ZohoReconnectionRedirectParams
  | AutomationLogsRedirectParams
